import { Styled } from '.';
import { useI18n } from 'contexts/i18n';

const LogoRequirements = () => {
const i18n = useI18n();
  return (
    <Styled.Section>
      <Styled.Title>{i18n['Logo requirements']}:</Styled.Title>
      <Styled.RequirementList>
        <Styled.RequirementListItem>
          {i18n['Upload .png or .jpg']}
        </Styled.RequirementListItem>
        <Styled.RequirementListItem>
          {i18n['Min resolution of the file must be 200 DPI.']}
        </Styled.RequirementListItem>
        <Styled.RequirementListItem>
          {i18n['Upload only your original content. See IDS']}{' '}
          <Styled.Link
            href="https://www.invisalign.com/terms-of-use"
            target="_blank"
          >
            {i18n['Terms of Use']}
          </Styled.Link>
        </Styled.RequirementListItem>
      </Styled.RequirementList>
    </Styled.Section>
  );
};

export default LogoRequirements;
